import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapper: theme => css`
    background-color: ${theme.colors.neutral[100]};
    height: 1px;
    margin: 16px 0;
  `,
})

export default useStyles
